import { createSlice } from '@reduxjs/toolkit';

type VotesSliceType = {};

const initialState: VotesSliceType = {};

export const votesSlice = createSlice({
  name: 'votes',
  initialState,
  reducers: {},
});

export const {} = votesSlice.actions;
